import { __awaiter } from "tslib";
import { ConfigurationChangeEvent } from "@plansoft-configuration-renderer/events";
import { handleConfigurationEvent } from "../events/handleConfigurationEvent";
import { decrementOpenRequests, incrementOpenRequests, } from "../reducers/actions";
import { getSelectors, getSessionId } from "../reducers/selectors";
import { handleCfgStateResponse } from "./handleCfgStateResponse";
export function deleteSubCfgObject(params) {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, { cfgApi }) {
        try {
            dispatch(incrementOpenRequests());
            const rootState = getState();
            const sessionid = getSessionId(rootState);
            const selectors = getSelectors(rootState);
            // call api
            const response = yield cfgApi.deleteSubConfiguration({
                id: sessionid,
                deleteSubConfigurationParams: Object.assign({ selectors }, params),
            });
            // set response
            dispatch(handleCfgStateResponse(response));
            dispatch(handleConfigurationEvent(new ConfigurationChangeEvent(response.id)));
        }
        finally {
            dispatch(decrementOpenRequests());
        }
    });
}
//# sourceMappingURL=deleteSubCfgObject.js.map